/** A rejected automatic analysis cannot quote its Google potential layout. */
export const solarRoofRecoveryMessage = (
  reason: string | null | undefined,
  basis: 'ANALYSIS' | 'MANUAL'
): string | null =>
  reason === 'NO_USABLE_FACES' && basis === 'ANALYSIS'
    ? 'Draw the roof by hand before creating an estimate. Satellite imagery is available, but no usable automatic roof outline was generated.'
    : null;
